module.exports = __webpack_public_path__ + "static/img/CONVOCATORIA_PUBLICA_TDE.ffb267a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CONVOCATORIA_PUBLICA_TDE.jpeg
// module id = Hx50
// module chunks = 9